import { useEffect, useState } from 'react'
import { Input, Select, Modal, Form, Button, Col, Row, Typography } from 'antd'
import { observer } from 'mobx-react-lite'
import { GLOBAL_CLIENT } from '../../helpers/GlobalClient'
import { useTranslation } from 'react-i18next'
import { useStore } from '../../hooks'
import { getPage } from '../../helpers/constants'
import { cloneDeep, debounce, trim } from 'lodash'
import styled from 'styled-components'
import CardItems from 'src/common/components/CardItems'

const formItemLayout = {
   labelCol: {
      xs: { span: 24 },
      sm: { span: 2 }
   },
   wrapperCol: {
      xs: { span: 24 },
      sm: { span: 22 }
   }
}

export const ModalSelectorWapper = styled.div`
   height: 100%;
   min-height: 0;
   flex: 1 1 auto;
   display: flex;
   flex-direction: column;

   .cursor-pointer {
      cursor: pointer;
   }

   .select-product-form {
      flex: 0 0 auto;
   }

   .select-product-summary {
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 0 10px;
      color: #595959;
      font-size: 13px;
   }

   .select-product-summary .ant-btn-link {
      height: auto;
      padding: 0;
      font-size: 13px;
   }

   .select-product-list {
      flex: 1 1 auto;
      min-height: 0;
      overflow-y: auto;
   }

   @media screen and (max-width: 820px) {
   }
`
const ProductSelectorModal = styled(Modal)`
   .ant-modal-content {
      height: calc(100vh - 48px);
      max-height: calc(100vh - 48px);
      display: flex;
      flex-direction: column;
   }

   .ant-modal-body {
      flex: 1 1 auto;
      min-height: 0;
      overflow: hidden;
      display: flex;
      flex-direction: column;
   }

   .ant-modal-footer {
      flex: 0 0 auto;
   }

   @media screen and (max-width: 575px) {
      .ant-modal-content {
         height: calc(100vh - 24px);
         max-height: calc(100vh - 24px);
      }
   }
`
const SelectProductModal = observer((props: any) => {
   const { t } = useTranslation()

   const { item, visible, onOk, onCancel, onlyView } = props
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   const [isChangePassword, setIsChangePassword] = useState(false)

   const [searchValue, setSearchValue] = useState('')
   const [status, setStatus] = useState(parseInt(item?.status))
   const UserStore = useStore('UserStore')
   const AuthStore = useStore('AuthStore')
   const role: any = AuthStore.data_role
   const [form] = Form.useForm()
   const { Title, Text } = Typography
   const [tags, setTags] = useState<any>([])
   const [tagSelected, setTagSelected] = useState([])
   const CommonConfigStore = useStore('CommonConfigStore')
   const { rows } = CommonConfigStore.tagList
   const [loop, setLoop] = useState([1, 2, 3, 4, 5, 6, 7])
   const OrdersStore = useStore('OrdersStore')
   const { rows: productRows, offset, count } = OrdersStore.products
   const [productsSelected, setProductsSelected] = useState<any[]>([])

   useEffect(() => {
      if (rows && rows?.length > 0) {
         const tag = rows.map((ro: any) => {
            return { value: ro?.id + '', label: ro?.name }
         })
         setTags(tag)
      }
   }, [rows])

   useEffect(() => {
      if (!rows || rows.length < 1) {
         const offset = getPage(0)
         const params = { offset, limit: 1000 }
         CommonConfigStore.getTagList(params)
      }
   }, [])

   useEffect(() => {
      if (OrdersStore.productsSelected.length) setProductsSelected(cloneDeep(OrdersStore.productsSelected))
   }, [])

   useEffect(() => {
      const offset = getPage(0)
      const params = { offset, limit: 100, status: 1, priceWithAccount: OrdersStore.sellerId }
      OrdersStore.getProducts(params)
   }, [])

   const handleChangeTag = (tag: any) => {
      console.log('tag', tag)
      setTagSelected(tag)
      const offset = getPage(0)
      const params = { offset, limit: 100, status: 1, name: searchValue, ...{ tags: tag.toString() } }
      OrdersStore.getProducts(params)
   }
   const handleChangeTextSearch = (value: any) => {
      const offset = getPage(0)
      const textSearch = trim(value) || ''
      setSearchValue(textSearch)
      const params = { offset, limit: 100, status: 1, name: textSearch, ...{ tags: tagSelected.toString() } }
      OrdersStore.getProducts(params)
   }
   const handleChangeText = (value: any) => {
      console.log('value', value?.target?.value)

      const offset = getPage(0)
      const textSearch = trim(value?.target?.value) || ''
      setSearchValue(textSearch)
      const params = { offset, limit: 100, status: 1, name: textSearch, ...{ tags: tagSelected.toString() } }
      OrdersStore.getProducts(params)
   }

   const handSelectProduct = (item: any) => {
      handleSelectProducts(item)
   }

   const handleSelectProducts = (item: any) => {
      const isProductExist = productsSelected.findIndex((p: any) => p.id === item.id)

      if (isProductExist > -1) return setProductsSelected(productsSelected.filter((p: any) => p.id !== item.id))

      setProductsSelected((prev: any) => [...prev, item])
   }

   const handleClearSelected = () => {
      setProductsSelected([])
   }

   const onSave = () => {
      OrdersStore.setProductsSelected(productsSelected)
      onOk()
   }

   const renderContent = () => {
      return (
         <ModalSelectorWapper>
            <Form
               {...formItemLayout}
               form={form}
               name="SellectProduct"
               scrollToFirstError
               className="select-product-form"
            >
               <Row>
                  <Col span={24}>
                     <Input.Search
                        placeholder="Tên sản phẩm"
                        allowClear
                        onChange={debounce(handleChangeText, 700)}
                        onSearch={handleChangeTextSearch}
                     />
                  </Col>
               </Row>
               <Form.Item name="tags" label={'Tag'}>
                  <Select
                     mode="multiple"
                     placeholder="Chọn"
                     defaultValue={tagSelected}
                     options={tags}
                     onChange={(value) => handleChangeTag(value)}
                  />
               </Form.Item>
            </Form>
            <div className="select-product-summary">
               <span>{productsSelected.length ? `Đã chọn ${productsSelected.length} mẫu` : 'Chưa chọn mẫu'}</span>
               {productsSelected.length > 0 && (
                  <Button type="link" onClick={handleClearSelected}>
                     Bỏ chọn tất cả
                  </Button>
               )}
            </div>
            <CardItems
               listCard={productRows}
               onSelect={handSelectProduct}
               style={{}}
               itemsSelected={productsSelected}
               classNameItem="gx-mx-0 cursor-pointer"
               className="select-product-list"
               imageSize={64}
               showSelectionStatus
            />
         </ModalSelectorWapper>
      )
   }

   return !onlyView ? (
      <ProductSelectorModal
         width={'90%'}
         style={{ maxWidth: '700px' }}
         visible={visible}
         centered
         title={'Chọn sản phẩm'}
         okText={t(GLOBAL_CLIENT.save)}
         cancelText={t(GLOBAL_CLIENT.close)}
         onCancel={onCancel}
         onOk={onSave}
      >
         {renderContent()}
      </ProductSelectorModal>
   ) : (
      <ProductSelectorModal
         width={'90%'}
         style={{ maxWidth: '700px' }}
         visible={visible}
         centered
         title={'Chọn sản phẩm'}
         okText={t(GLOBAL_CLIENT.edit)}
         cancelText={t(GLOBAL_CLIENT.huy)}
         onCancel={onCancel}
         onOk={onSave}
         footer={[
            <>
               <Button key="back" onClick={onCancel}>
                  Đóng
               </Button>
            </>
         ]}
      >
         {renderContent()}
      </ProductSelectorModal>
   )
})

export default SelectProductModal
